import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import Button from '../../../shared/_TBComponents/Button';
import SharedModal from '../../../shared/_TBComponents/Modal';
import Text from '../../../shared/_TBComponents/Text';

const ConfirmContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 100%;
`;

const ConfirmFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 20px;
`;

// Destructive action confirm shared by both pages
const ConfirmActionModal = ({
  isOpen, title, message, confirmLabel, isBusy, overlayBackgroundColor, onConfirm, onClose,
}) => (
  <SharedModal
    isOpen={isOpen}
    onRequestClose={onClose}
    customBorderRadius='8px'
    customPadding='24px'
    customMaxWidth='400px'
    customMinHeight='auto'
    overlayBackgroundColor={overlayBackgroundColor}
  >
    <ConfirmContent>
      <Text styledTextProps={{ fontSize: '18px', fontWeight: 600, marginBottom: '16px' }}>
        {title}
      </Text>
      <Text styledWrapperProps={{ marginBottom: '16px' }}>{message}</Text>
      <ConfirmFooter>
        <Button
          type='button'
          name='Cancel'
          fontSize='14px'
          txtColor='#757575'
          bgColor='#FFF'
          borderColor='#EEEEEE'
          customBorderRadius='6px'
          styledTextProps={{ fontWeight: 600 }}
          onClick={onClose}
        />
        <Button
          type='button'
          name={isBusy ? 'Working...' : confirmLabel}
          fontSize='14px'
          txtColor='#FFF'
          bgColor='#FF0505'
          borderColor='#FF0505'
          customBorderRadius='6px'
          styledTextProps={{ fontWeight: 600 }}
          disabled={isBusy}
          onClick={onConfirm}
        />
      </ConfirmFooter>
    </ConfirmContent>
  </SharedModal>
);

ConfirmActionModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string,
  message: PropTypes.string,
  confirmLabel: PropTypes.string,
  isBusy: PropTypes.bool,
  overlayBackgroundColor: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

ConfirmActionModal.defaultProps = {
  title: '',
  message: '',
  confirmLabel: 'Confirm',
  isBusy: false,
  overlayBackgroundColor: undefined,
};

export default ConfirmActionModal;
